import React, { useContext } from 'react';
import { ICategoryContext, CategoryContext } from '../../../categoryState/categoryContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, categories } = useContext<ICategoryContext>(CategoryContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={categories.totalCount ? 800 : undefined}
		/>
	);
};
